import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contentId", "hubId"];
/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/learningContent/components/AIGeneratedContentBanner.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { GENERATION_PORTAL_ID, GENERATION_PORTAL_ID_QA } from '../../accounts/accountsConstants.legacy';
import CompanionFooter from '../../interactiveEducation/components/CompanionFooter.migrated';

/* Temp hardcoded content id */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AI_GENERATED_CONTENT_ID_QA = 88707689;
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/learningContent/components/AIGeneratedContentBanner.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const AIGeneratedContentBanner = _ref => {
  let {
      contentId,
      hubId
    } = _ref,
    viewProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const expectedPortalId = enviro.isQa() ? GENERATION_PORTAL_ID_QA : GENERATION_PORTAL_ID;
  const matchesPortalId = hubId === expectedPortalId;

  // Temporarily, enable banner for existing QA content - until we get test content on QAportal 911635575
  const isQaTestContent = enviro.isQa() && contentId === AI_GENERATED_CONTENT_ID_QA;
  if (!matchesPortalId && !isQaTestContent) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, Object.assign({}, viewProps, {
    children: [/*#__PURE__*/_jsxs(Text, {
      as: "h5",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: ArtificialIntelligenceIcon,
        paddingInlineEnd: "200",
        paddingInlineStart: "0"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.aiContent.aiGeneratedBanner"
      })]
    }), /*#__PURE__*/_jsx(CompanionFooter, {
      contentType: "SHORT_FORM_CONTENT",
      flush: true,
      noBorder: true,
      primaryContentId: contentId,
      trackingAction: "AI_GENERATED_CONTENT_FEEDBACK"
    })]
  }));
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/learningContent/components/AIGeneratedContentBanner.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default AIGeneratedContentBanner;